import React from "react";
import "../../App.css";
import alps1 from "./IMGsmall/alps1.jpg";
import alps2 from "./IMGsmall/alps2.jpg";
import alps3 from "./IMGsmall/alps3.jpg";
import Footer from "./Footer";

export default function France() {
  return (
    <>
      <div class="france">
        <h1>FRENCH ALPS</h1>
        <div class="IMGsmoll">
          <img class="alps" alt="summer Alps" src={alps1} />
          <img class="alps" alt="Grenoble" src={alps2} />
          <img class="alps" alt="winter Alps" src={alps3} />
        </div>
      </div>
      <Footer />
    </>
  );
}
